import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class PropertyPathTokenService {

    /**
     * @param stringWithTokens Takes a string with possibly multiple tokens
     * e.g token number 1 [token.1] and token 2 is [token.2] with /n.
     * the tokens resemble properties and will be replaced if present on the object.
     * @param object Object where the properties will be looked up on. if present
     * return their value if not return the raw token, e.g. token.1
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public replaceStringTokens(stringWithTokens: string, object: Record<string, any>): string {
        const keyValues =
            // eslint-disable-next-line sonarjs/slow-regex
            stringWithTokens.match(/\[([^\]]+)\]/g)?.map(match => {
                const key = match.slice(1, -1);
                const valueFromObject = this.getValueFromObjectByKey(object, key);

                return { match, valueFromObject };
            }) ?? [];

        let replacedString = stringWithTokens;
        keyValues.forEach(pair => {
            replacedString = replacedString.replace(pair.match, pair.valueFromObject);
        });

        return replacedString;
    }

    /**
     * @param object The Object on which the key is asserted on.
     * @param key Key of the object. Dot notation is required, for example address.city.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private getValueFromObjectByKey(object: Record<string, any>, key: string): any {
        const keyParts = key.split('.');

        return keyParts.reduce((acc, curr) => {
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!acc) {
                return '';
            }

            return acc[curr] ?? '';
        }, object);
    }
}
